import React from 'react'
import { ShareWithoutVersion } from 'modules/versioning'
import { VersionFragment } from '@sketch/gql-types'

// Components
import {
  Flex,
  CopyToClipboard,
  Text,
  TruncateWithTooltip,
} from '@sketch/components'
import {
  StyledModal as Modal,
  Title,
  PreviewImage,
  PreviewImageEmpty,
} from './SharingModal.styles'

export const SharingModalHeader = ({
  share,
  latestVersion,
}: {
  share: ShareWithoutVersion
  latestVersion: VersionFragment
}) => {
  const thumbnails = latestVersion?.document?.previewFile?.thumbnails
  const image = thumbnails ? thumbnails[0]?.url : undefined

  const projectName = share.project?.name
  const workspaceName = share.workspace.name

  return (
    <Modal.Header>
      <Flex alignItems="center" mb={6} height={92}>
        {image ? (
          <PreviewImage alt={share.name} src={image} />
        ) : (
          <PreviewImageEmpty data-testid="share-image-placeholder" />
        )}
        <Flex ml={6} mr={6} flex={1} flexDirection="column">
          <Title>
            Share <strong>{share.name}</strong>
          </Title>
          <Text fontSize="F" fontWeight="regular" as="div">
            <TruncateWithTooltip width={350}>
              {projectName
                ? `in ${projectName} / ${workspaceName}`
                : `in ${workspaceName}}`}
            </TruncateWithTooltip>
          </Text>
        </Flex>
        <CopyToClipboard
          size="40"
          showIcon={false}
          value={share.publicUrl}
          title={
            share.publicAccessLevel !== 'NONE'
              ? 'Copy Public Link'
              : 'Copy Link'
          }
        />
      </Flex>
    </Modal.Header>
  )
}
